import { render, staticRenderFns } from "./sowhatbuy-guarantee-marquee.vue?vue&type=template&id=5685b4ce&scoped=true&"
import script from "./sowhatbuy-guarantee-marquee.vue?vue&type=script&lang=js&"
export * from "./sowhatbuy-guarantee-marquee.vue?vue&type=script&lang=js&"
import style0 from "./sowhatbuy-guarantee-marquee.vue?vue&type=style&index=0&id=5685b4ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685b4ce",
  null
  
)

export default component.exports